import React from 'react';
import LegalDocumentPage from '../components/LegalDocumentPage';
import { agreementSections } from '../config/compliance';

export default function UserAgreement() {
  return (
    <LegalDocumentPage
      title="用户协议"
      sections={agreementSections}
      relatedLinks={[{ to: '/privacy', label: '隐私政策' }]}
    />
  );
}
